import classNames from 'classnames';
import { Checkbox, CheckboxProps } from '~/components/Form';
import styles from './NftCheckbox.module.scss';

export type NftCheckboxProps = CheckboxProps;
export const NftCheckbox = ({ children, className, title, ...props }: NftCheckboxProps) => (
  <label className={classNames(styles.root, className)}>
    <Checkbox className={styles.checkbox} variant="circle" {...props} />
    <span>{children}</span>
    <span className={styles.title}>{title}</span>
  </label>
);
